export const commonConstants = {
  loginErrorMsg: "Login Required/Expired. Please Login Again",
  commonErrorMsg: "Unknown Error",
};
